// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
    PagePerformanceProfileObsService,
} from '@client/app/modules/page-performance/services/profile-obs/profile-obs.service';
import {
    AssignedProfilesRepoService,
} from '@client/app/services/api/page-performance/assigned-profile-repo/assigned-profiles-repo.service';
import {
    PagePerformanceProfileService,
} from '@client/app/services/entities/page-performance/page-performance-profile.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'form-page-performance-confirm-archive',
    standalone: false,
    template: `
<div class="form-page-performance-confirm-archive">
    <div class="modal-header d-flex">
        <h1 class="font-size-18 mr-auto">
            <span aria-hidden="true"
                  class="text-orange fas fa-exclamation-triangle mr-1">
            </span><span>{{'Warning' | translate}}</span>
        </h1>
        <div>
            <span class="fas fa-times text-grey fa-lg"
                  [attr.aria-label]="'Close' | translate"
                  role="button"
                  (click)="cancel()">
            </span>
        </div>
    </div>
    <div class="modal-body">
        <table-container
            *ngIf="showTable()"
            [collection]="assignedProfiles"
            (onPageChange)="onPageChange($event)"
            (onPerPageChange)="onPageSizeChange($event)"
            [progress]="promise">
            <p translate [translate-args]="{profileName: profile.name}">
                The profile <strong>[[profileName]]</strong> is being used on the following pages below:
            </p>
            <div class="card panel-monsido-card">
                <div class="card-body archive-profile">
                    <table class="table table-fixed">
                        <thead>
                        <tr>
                            <th translate>Title and URL</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let assignedProfile of assignedProfiles"
                            [ngClass]="{'notice-danger': hasLastProfile(assignedProfile)}">
                            <td class="text-ellipsis align-items-center">
                                <div class="d-flex align-items-center">
                                    <div class="text-ellipsis mr-auto">
                                        <url-title class="text-ellipsis"
                                                   [title]="assignedProfile.page.title"
                                                   [url]="assignedProfile.page.url">
                                        </url-title>
                                    </div>
                                    <div *ngIf="hasLastProfile(assignedProfile)" class="ml-3">
                                        <span aria-hidden="true"
                                              [ngbTooltip]="'Last assigned profile on page. Page will be removed from Performance' | translate"
                                              placement="top-right"
                                              class="text-orange fas fa-fw fa-exclamation-triangle fa-2x">
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </table-container>
        <p *ngIf="!showTable()"
           translate
           [translate-args]="{profileName: profile.name}">
            Are you sure you would you like to archive this profile <strong>([[profileName]])</strong>?
            Archiving this profile means it won't show up in your modules anymore.
            If you wish to still use the profile in the future restore it from the dropdown in the Archived profiles
            menu.
        </p>
    </div>
    <div class="modal-footer text-right bg-light-grey">
        <button class="btn btn-border-radius btn-secondary mr-1"
                type="button"
                (click)="cancel()"
                translate>
            Cancel
        </button>
        <button class="btn btn-border-radius btn-marine-blue"
                type="button"
                (click)="archive()"
                translate>
            OK
        </button>
    </div>
</div>
    `,
})
export class FormPagePerformanceConfirmArchiveComponent extends BaseContainerComponentController implements OnInit {
    @Input() resolve: any;
    @Output() close = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<any>();

    profile: any;
    assignedProfiles: any[] = [];
    promise: any = null;
    loading: boolean = false;
    saving: boolean = false;

    constructor (
        private assignedProfileRepoService: AssignedProfilesRepoService,
        private pagePerformanceProfileService: PagePerformanceProfileService,
        private pagePerformanceProfileObsService: PagePerformanceProfileObsService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.profile = this.resolve.profile;
        this.assignedProfiles = [];
        this.promise = null;
        this.loading = false;
        this.saving = false;
        this.getPage();
    }

    override getPage = (): void => {
        const params = {
            profile_id: this.profile.id,
            page: this.page,
            page_size: this.pageSize,
        };

        this.loading = true;
        this.promise = this.assignedProfileRepoService.getAll(params)
            .then((assignedProfiles: any) => {
                this.assignedProfiles = assignedProfiles;
            }, () => {
                // angular.noop equivalent
            })
            .finally(() => {
                this.loading = false;
            });
    };

    hasLastProfile (assignedProfile: any): boolean {
        return assignedProfile.profile_ids.length <= 1;
    }

    showTable (): boolean {
        return this.loading || (this.assignedProfiles && this.assignedProfiles.length > 0);
    }

    archive (): void {
        this.profile.archive = true;
        this.saving = true;
        this.pagePerformanceProfileService.archive(this.profile)
            .then(() => {
                this.pagePerformanceProfileObsService.removeProfile(this.profile);
                this.closeModal();
            }, () => {
            })
            .finally(() => {
                this.saving = false;
            });
    }

    cancel (): void {
        this.dismiss.emit();
    }

    closeModal (): void {
        this.close.emit({ $value: this.profile });
    }
}
